<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AODN8V/tc-custom/9780544716223.jpg?1709153015566" alt="This image is the cover for the book Spill Simmer Falter Wither"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spill Simmer Falter Wither
      </h1>
      <p class="bookDescription body article font2">
        <b>An old loner and his misfit dog spend a year on the road in this acclaimed Irish novel of “singing prose [and] two unlikely Beckettian wanderers” (<i>The Guardian</i>, UK).</b><br/>  <br/> It is springtime, and an isolated man shunned by his village has forged a connection with the one-eyed dog he’s taken into his tightly shuttered life. But as their friendship grows, their small seaside community becomes suspicious. And when an accident is misconstrued as menace, this pair of outcasts must take to the road. As they travel from town to town, sleeping in the car and subsisting on canned spaghetti, the man confides in One Eye the strange and melancholy story of his life.<br/>  <br/> With its gorgeously poetic prose, S<i>pill Simmer Falter Wither</i> has garnered enthusiastic praise in its native Ireland, where the <i>Irish Times </i>pointed to Baume’s “astonishing power with language” and praised it as “a novel bursting with brio, braggadocio and bite.” <br/>  <br/><b>“Baume has a rare ability to look afresh at muted scenes and ordinary objects… the book hums with its own distinctiveness.”—<i>The Guardian</i>, UK</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sara Baume
      </h2>
      
      <p class="authorDescription body article">Sara Baume studied fine art before earning a Master’s in Creative Writing. Her short fiction has appeared in the The Moth, The Stinging Fly, the Irish Independent, and others. She won the 2014 Davy Byrnes Short Story Award and the 2015 Hennessy New Irish Writing Award. She lives in Cork with her two dogs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3db00744